import { PersonSettlementTourType } from '@api';
import { ArtistAnchor, TourAnchor } from '@common';
import { DataTableColumn } from 'mantine-datatable';
import { useTranslation } from 'react-i18next';
import { CoHeadlinerTableCell } from './components';
import { getPersonSettlementCoHeadliners } from './helpers';

export type UsePersonSettlementsColumnsReturnType = {
  columns: DataTableColumn<PersonSettlementTourType>[];
};

export const usePersonSettlementsColumns =
  (): UsePersonSettlementsColumnsReturnType => {
    const { t } = useTranslation('personDetailsSettlements');

    const columns: DataTableColumn<PersonSettlementTourType>[] = [
      {
        accessor: 'tour',
        title: t('TABLE_COLUMNS.TOUR_NAME'),
        render: (record) => <TourAnchor tour={record.tour} />,
      },
      {
        accessor: 'artist',
        title: t('TABLE_COLUMNS.ARTIST'),
        render: (record) => <ArtistAnchor artist={record.artist} />,
      },
      {
        accessor: 'coHeadliner',
        title: t('TABLE_COLUMNS.CO_HEADLINER'),
        render: (record) => (
          <CoHeadlinerTableCell
            coHeadliners={getPersonSettlementCoHeadliners({
              coHeadliner1: record.coHeadliner1,
              coHeadliner2: record.coHeadliner2,
            })}
          />
        ),
      },
      {
        accessor: 'tourYear',
        title: t('TABLE_COLUMNS.TOUR_YEAR'),
        render: (record) => record.tourYear,
      },
    ];

    return { columns };
  };
